import Stack from '@mui/material/Stack';
import { useEffect, useRef } from 'react';
import type { Turn } from '../model/conversation';
import { AssistantMessage } from './AssistantMessage';
import { UserMessage } from './UserMessage';

/** The questions asked before this turn: the context an analyst sees if this one goes to the desk. */
const earlier = (turns: Turn[], id: string) => turns.slice(0, turns.findIndex((t) => t.id === id)).map((t) => t.question);

/** The conversation, question then answer, shared by the side panel and the full page. */
export function MessageThread({ turns, onAsk }: { turns: Turn[]; onAsk?: ((question: string) => void) | undefined }) {
  const endRef = useRef<HTMLDivElement>(null);
  const last = turns.at(-1);

  useEffect(() => { endRef.current?.scrollIntoView({ block: 'end' }); }, [turns.length, last?.steps.length, last?.draft, last?.answer]);

  return (
    <Stack sx={{ gap: 3.5 }} aria-live="polite">
      {turns.map((t) => (
        <Stack key={t.id} component="article" aria-label={`Question: ${t.question}`} sx={{ gap: 2.5 }}>
          <UserMessage text={t.question} />
          <AssistantMessage turn={t} onAsk={onAsk} context={earlier(turns, t.id)} />
        </Stack>
      ))}
      <div ref={endRef} />
    </Stack>
  );
}
